import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {BehaviorSubject, isObservable, lastValueFrom, map, of, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';


import {SweetAlertResult} from 'sweetalert2';
import {
  END_USER_HIDDEN_FIELDS
} from './data-constants';
import {DataTableDirective} from './data-table.directive';
import {Action} from '@ngrx/store';
import {ofType} from '@ngrx/effects';
import {Column} from 'exceljs';
import {APP_NAME} from "../../constants/data.constants"

import {AllDetailsComponent} from "../all-details/all-details.component";
import {MtxGridColumn} from "@ng-matero/extensions/grid";
import {HttpHeaders} from "@angular/common/http";
import {GraphqlService} from "../../../services/graphql.service";

import {
  CurrentSort,
  INITIALIZED_PAGEABLE_PARAMETER,
  PageableParamInput,
  PageableResponse,
  SearchFieldsDtoInput,
} from "../../../store/entities/shared/page/page.model";
import {SearchState} from "../../../common/interfaces/data.interfaces";
import {SearchOperationType} from "../../../common/interfaces/global-interfaces";
import _default from "mermaid/dist/themes";
import {DarkModeService} from "../../../services/dark-mode.service";

@Component({
  selector: 'app-data-table-hybrid',
  templateUrl: './data-table-hybrid.component.html',
  styleUrls: ['./data-table-hybrid.component.scss'],
})
export class DataTableHybridComponent
  extends DataTableDirective
  implements OnInit, OnChanges, OnDestroy {

  constructor(
      private  graphqlService :GraphqlService
  ) {
    super();
  }
  @Input() title = 'Data';
  @Input() icon = 'clear_all';
  @Input() animation = 'move-left';
  @Input() class = '';
  @Input() noDataLabel = undefined;
  @Input() showSearchFields = true;
  @Input() statusFilters=false;
  @Input() tableData: any = new BehaviorSubject([]);
  @Input() allTableData = [];
  @Input() upsertAction: Action = undefined;
  @Input() customLoadAction: Action = undefined;
  @Input() deleteAction: Action = undefined;
  @Input() columnHeader = undefined;
  @Input() selectQuery = undefined;
  @Input() hiddenFieldsKeys = [];
  @Input() columnsKeys = [];
  @Input() dropDownSelectKey=[];
  @Input() dropDownVariables=[];
  @Input() multipleSelect=[];
  @Input() placeholder =[];
  @Input() useOuterSearchField: boolean = false;
  @Input() outerSearch;
  listData: MatTableDataSource<any>;
  pageIndex = 0;
  dropDownData=[]
  dataLength: number;
  pagesLength = 0;
  displayedPageIndex = 0;
  selectedColumnsKeys: string[] = [];
  defaultColumnsKeys: string[] = [];
  selectedExportKeys: string[] = [];
  allFieldsKeys: string[] = [];
  originalFieldsKeys: string[] = [];
  visibleItemsMod = [];
  visibleItems = [];
  exportPageIndex = 0;
  @Input() hasActionsColumn = true;
  @Input() pageSizeOptions: number[] = [5, 10, 50, 100, 250];
  @Input() pageSize = 10;
  @Input() query = undefined;
  @Input() isPageable = false;
  @Output() pageable = new EventEmitter<PageableParamInput>();
  @Input() queryVariables = undefined;
  @Input() additionalQueryParameter = undefined;
  pageParam: any = INITIALIZED_PAGEABLE_PARAMETER;
  isLoading = true;
  loadingTimer = undefined;
  queryIsRunning = false;
  pageDetails: PageableResponse<any> = undefined;
  searchInputStates: SearchState[] = [];
  previousInputStates: SearchState[] = [];
  @Input() pageableParamInput: PageableParamInput = INITIALIZED_PAGEABLE_PARAMETER;
  @Input() searchOperationType = SearchOperationType.Like;
  @Input() searchDelayTime = 2000;
  @Input() searchFields: SearchFieldsDtoInput[];
  @Input() searchKeys: string[] = [];
  @Input() searchStates: SearchState[] = [];
  @Input() searchStatesValues: SearchState[] = [];
  searchTimer = undefined;
  currentSearch: SearchFieldsDtoInput[] = [];
  hasTouchedSearchInput = false;
  selectedSearchKeys: string[] = [];
  searchHiddenKeys: string[] = ['sn', 'id', 'actions', 'reportQuery'];
  @Input() sortKeys: string[] = [];
  @Input() currentSort: CurrentSort = {sortBy: 'id', sortDirection: 'DESC'};
  @Input() sortKeysMap = ['key as key.innerKey'];
  @Output() onDataLength = new EventEmitter();
  @Output() onLoadData = new EventEmitter();
  @Output() rowSelectionChange = new EventEmitter<any[]>();
  @Output() cellSelectionChange = new EventEmitter<any[]>();
  selectedRows: any[] = [];
  @Input() isEnum =[];
  selectedCells: any[] = [];
  @Input() dateFilterKeys: string[] = [];
  @Input() dateRange: { key?: string; fromDate?: string; toDate?: string } = undefined;
  selectedDateRangeKey = undefined;
  selectedDateKey = undefined;
  allDateKeys = [];
  dateValue: any;
  startDateValue = undefined;
  endDateValue = undefined;
  @Input() exportAllFields = false;
  @Input() searchByAllFields = false;
  @Input() exportAllData = false;
  @Input() maxColumnCount = 6;
  @Input() searchByMultipleKeys = false;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ContentChild('actions', {static: true}) actions: TemplateRef<any>;
  @ContentChild('expansion', {static: true}) expansion: TemplateRef<any>;
  userIsInternal = false;
  subscriptions: Subscription = new Subscription();
  filtersContainerClass = `bg-white rounded-small border-slightly-faded p-2
  pt-1 d-flex flex-wrap align-items-center w-100`;

  @Input() mapFunction: (item: any) => {} = (item: any) => ({...item});

  objectKeys = (obj = {index: 'S/N'}) => Object.keys(obj);

  columnIsHidden = key => this.ds.valueIncludes(key, this.hiddenFieldsKeys ?? []);

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData();
  }

  ngOnInit() {
    this.initialColumns = this.columns;
    this.loadData();
    this.getDataForSelect()
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadFromPreviousPageEvent(pageDetails) {
    this.isPageable = true;

    const prevTableEvent: PageEvent = {
      length: pageDetails?.totalElements,
      pageIndex: pageDetails.number,
      pageSize: pageDetails.size,
      previousPageIndex: pageDetails.number > 0 ? pageDetails.number - 1 : 0,
    };

    this.handlePage(prevTableEvent);
  }

  loadData() {
    const isNotObs = !isObservable(this.tableData) && this.tableData?.length;
    if (isNotObs) this.tableData = of(this.tableData);

    try {
      this.userIsInternal = localStorage?.getItem('userType') === 'INTERNAL';
    } catch (e) {
      console.log('SSD Err');
    }

    //set search fields // start with previous search data
    this.setSearchParemeters();

    // if provided keys set tableheader
    if (this.columnsKeys.length) {
      this.columnHeader = this.ts.columnHeaderFromKeys(this.columnsKeys, this.hasActionsColumn);
    }

    // wait 100 miliseconds then loadData;
    if (this.loadingTimer) clearTimeout(this.loadingTimer);
    this.loadingTimer = setTimeout(() => {
      this.loadTableData();
    }, 100);

    if (this.upsertAction) {
      this.subscriptions.add(
        this.actions$.pipe(ofType(<any>this.upsertAction)).subscribe(data => this.upsertData(data))
      );
    }
    if (this.customLoadAction) {
      this.subscriptions.add(
        this.actions$.pipe(ofType(<any>this.customLoadAction)).subscribe(data => this.loadDataOnAction(data))
      );
    }
    if (this.deleteAction) {
      this.subscriptions.add(
        this.actions$.pipe(ofType(<any>this.deleteAction)).subscribe(data => this.removeData(data))
      );
    }
  }

  upsertData(event) {
    let data;
    [0, 1].forEach(i => !data && (data = this.fs.fieldsArrayFromObj(event)?.[i].value)?.id);
    if (!data) return;
    if (Array.isArray(data)) {
      data.forEach(x => {
        const items = [x].concat(this.visibleItems.filter(item => item.id !== x.id));
        this.tableData.next(items);
      });
    } else {
      const items = [data].concat(this.visibleItems.filter(item => item.id !== data.id));
      this.tableData.next(items);
    }
  }

  removeData(event) {
    const items = this.visibleItems.filter(item => item.id.toString() !== event?.id);
    this.tableData.next(items);
  }

  loadDataOnAction(event) {
    let data;
    [0, 1].forEach(i => !data && (data = this.fs.fieldsArrayFromObj(event)?.[i].value)?.id);
    this.tableData.next(data);
  }

  loadTableData() {
    if (this.query) {
      try {
        this.pageDetails = this.storage.get(this.getQueryKey(this.query));
      } catch (e) {
        console.log('SSD Err');
      }
      this.tableData = new BehaviorSubject([]);
      // ignore large and small sizes from local storage
      if (this.pageDetails?.size > 50) this.pageDetails.size = 50;
      if (this.pageDetails?.size < 10) this.pageDetails.size = 10;
      if (this.pageDetails?.size) this.loadFromPreviousPageEvent(this.pageDetails);
      else this.setTableDataFromQuery(this.query);
    }

    this.subscriptions.add(
      this.tableData?.subscribe(data_ => {
        this.isLoading = true;
        //perform local search if initialized with state values;
        // using exactness for now // ignoring searchType
        if (!this.isPageable)
          this.currentSearch?.forEach(field => {
            const hasKey = data_?.[0]?.[field.fieldName];
            hasKey && (data_ = data_.filter(f => f[field.fieldName] === field.fieldValue));
          });

        // map data
        const data = [...data_]?.map(item =>
          this.mapFunction(item) ? this.mapFunction(item) : item
        );
        this.visibleItems = data;
        this.visibleItemsMod = [...data].map(item => this.fs.mapVisibleItem(item));

        // set columnHeader before assigning values to paginator/
        const setAutoColumns = !this.columnHeader && data.length && !this.columns?.length;
        if (setAutoColumns) this.setTableColumnsFromObject(data[0]);
        if (this.columnHeader) this.setMtxColumns(this.columnHeader);
        this.setDefaultColumnsKeys();
        this.setEntityKeysGroups(data[0], data_[0]);

        this.listData = new MatTableDataSource(data);
        this.listData.sort = this.sort;
        if (!data?.length) return;

        // get page details
        const pageDetailsKey = this.query ? this.getQueryKey(this.query) : 'pageDetails';
        try {
          this.pageDetails = this.storage.get(pageDetailsKey);
        } catch (e) {
          console.log('SSD Err');
        }

        // page Details
        const size = this.pageDetails?.size;
        const totalElements = this.pageDetails?.totalElements;
        const index = this.pageDetails?.number;
        this.dataLength = totalElements ?? data?.length;

        if (!this.isPageable) {
          const p_size = this.paginator.pageSize;
          const p_index = this.paginator.pageIndex;
          const inIndex = p_size * (p_index + 1) < this.dataLength;

          if (inIndex) this.paginator.pageIndex = index ?? this.pageIndex;
          this.paginator.pageSize = size ?? this.pageSize;
          this.listData.paginator = this.paginator;
        }

        if (this.isPageable) {
          this.dataLength = totalElements ?? this.dataLength;
          this.pageSize = size >= 10 ? size ?? this.pageSize : 10;
          this.paginator.pageSize = size ?? this.pageSize;
        }

        this.updatePageDetails();
        this.onDataLength.emit(this.dataLength);
        this.onLoadData.emit(this.visibleItems);
        this.isLoading = false;
      })
    );
    let state: SearchState[] // kuweka search state empty
    this.removeSearchFields(state);// kuweka search state empty
  }

  setTableColumnsFromObject(object) {
    if (this.columnHeader) return;
    const fields = this.fs.formatFields(this.fs.fieldsArrayFromObj(object));
    const columnHeader_ = {index: '#'};

    fields.forEach((field, index) => {
      if (index <= this.maxColumnCount) columnHeader_[field.key] = field.name;
    });

    this.columnHeader = this.hasActionsColumn
      ? {...columnHeader_, actions: 'Actions'}
      : columnHeader_;
  }

  setSearchFieldsFromKeys() {
    // add fullName if given firstName and surname
    const keys_ = this.searchKeys?.map(x => x?.split('.')?.pop());

    const noFullName = !this.ds.valueIsEither('fullName', keys_);
    const canHaveFullName =
      noFullName && this.ds.arrayIncludesBoth(keys_, ['firstName', 'surname']);

    if (canHaveFullName) {
      const fNameKeyPrefix = this.searchKeys?.[keys_.findIndex(k => k === 'firstName')];
      const fullName = `${this.ds.getPrefix(fNameKeyPrefix, '.')}fullName`;
      this.searchKeys.splice(0, 0, fullName);
    }

    if (!this.searchKeys?.length) {
      this.searchFields = this.searchFields ?? [];
      return;
    }

    const searchType = this.searchOperationType;
    this.searchFields = this.searchKeys.map(k => ({ fieldName: k, searchType }));
    if (!this.sortKeys.length || this.searchByAllFields) this.sortKeys = this.searchKeys;
}

  setSearchParemeters() {
    this.currentSort = this.currentSort ?? {sortBy: 'id', sortDirection: 'DESC'};

    //if Keys provided // since we now force user to select a field to search
    this.setSearchFieldsFromKeys();

    // set the already predifined values else use loaded from storage
    let activeStates: SearchState[] = [];

    if (this.searchStatesValues?.length) {
      // locked search states are hidden, and not removed on clear
      const lockeState = s => ({...s, active: true, locked: true});
      let states: SearchState[] = this.searchStatesValues?.map(s => lockeState(s));
      if (this.showSearchStates) states = states?.concat(this.searchStates);
      this.searchStates = states;

      //by default stateValues are active
      activeStates = this.searchStatesValues ?? [];
    }

    // get search states from ls / filter the ones actually present in the provide searchStates
    let storageStates: SearchState[] = [];
    const temp = this.storage.get('activeSearchStates');
    const canUpdateStates = this.searchStates?.length && Array.isArray(temp);

    if (canUpdateStates) {
      storageStates = temp;
      const isValid = s =>
        this.ds.valueIncludes(
          s.key,
          this.searchStates.map(s => s.key),
          true
        );
      storageStates = storageStates?.filter(state => isValid(state));

      // copy states values from storage to states
      const setActive = (s_, s) => s_.key === s.key && (s.value = s_.value) && (s.active = true);
      this.searchStates?.forEach(s => storageStates?.find(s_ => setActive(s_, s)));

      // if active  // update storage states to active only
      const isActive = s => s.active || this.ds.isValue(s.value);
      const hasActive = (storageStates = this.searchStates.filter(s => isActive(s)))?.length;
      if (hasActive) this.hasTouchedSearchInput = true;
    }

    // intitialize current search if provided predefined values
    if (this.searchStatesValues) {
      this.currentSearch = this.searchStatesValues?.map(state => ({
        fieldName: state.key,
        fieldValue: state.value,
        searchType: state.searchType ?? this.searchOperationType,
      }));

      const isState = (s, f) => s.key === f.fieldName && s.value === f.fieldValue;
      const getType = f => this.searchStatesValues?.find(s => isState(s, f))?.searchType;

      this.searchFields = this.searchFields?.map(field => ({
        ...field,
        searchType: getType(field) ?? field.searchType,
      }));
    }

    //combine from storage with provided states
    const foundInStates = s =>
      this.ds.valueIncludes(
        s.key,
        activeStates.map(a => a.key)
      );
    storageStates = storageStates?.filter(s => !foundInStates(s));
    if (storageStates?.length) activeStates = activeStates?.concat(storageStates);

    //get user typed key from storage // if there is search key show filter nomara wah
    const x = this.storage.get('searchInputStates');
    if (x?.length && (this.searchInputStates = x) && (this.alwaysShowFilter = true)) {
      activeStates = activeStates.concat(this.searchInputStates);
    }

    //updates the above intilized currentsearch  with states so far
    if (activeStates?.length) {
      const keys = this.searchStatesValues?.map(v => v.key);
      const isInStates = x => !this.ds.valueIncludes(x.key, keys, true);
      const trulyActive = activeStates.filter(x => isInStates(x));
      trulyActive?.forEach(state => this.updateCurrentSearch(state.key, state.value));
    }

    // if loading with a specified daterange // add to currentSearch and set locked on states
    if (this.dateRange?.fromDate && this.dateRange?.toDate && this.dateRange.key) {
      const keyInSearch = this.currentSearch.find(f => f.fieldName === this.dateRange.key);
      const keyInStates = this.searchStates.find(s => s.key === this.dateRange.key);

      const fieldName = this.selectedDateRangeKey;
      const searchType = SearchOperationType.Between;
      const fieldValues = [this.dateRange?.fromDate, this.dateRange?.toDate];
      const fieldValue = this.dateRange?.toDate;

      const state = {key: fieldName, value: fieldValue, locked: true, searchType};
      if (!keyInSearch) this.currentSearch.push({fieldName, searchType, fieldValue, fieldValues});
      if (!keyInStates) this.searchStates.push(state);
    }

    // update the searchDto to include values assigned
    let size = this.pageableParamInput?.size;
    if (size < 10) size = 10;
    const pageableParam = this.pageableParamInput;
    const searchFields = this.currentSearch;

    if(!this.useOuterSearchField)
      this.pageableParamInput = {
        ...this.pageableParamInput,
        ...pageableParam, size, searchFields
      };

    if(this.useOuterSearchField){

      this.pageableParamInput = {
        ...this.pageableParamInput,
        ...pageableParam, 
        size, 
        searchFields
      };

    }
  }

  log(...$event) {
    console.log($event);
    return true;
  }

  searchCustomState(e: { state: SearchState; value: any }) {
    this.hasTouchedSearchInput = true;
    const state: SearchState = e.state;
    const value = e.value;
    if (!state) return;

    // (clicked twice) remove the value  // else assign the new value
    value === state?.value ? (state.value = undefined) : (state.value = value);
    if (state.value === undefined) this.removeSearchFields(state);
    //rerender the states
    this.searchStates = [...this.searchStates];

    //if not pageable, there can only be one active
    if (!this.isPageable && !this.allTableData.length) {
      this.searchStates.forEach(s => s.key !== state.key && (s.value = undefined));
    }

    // mark active states// values in storage, // if user's input is present add it to active
    let activeStates: SearchState[] = this.searchStates.filter(
      s => (!!s.value || s.value === false) && !s?.locked
    );

    activeStates?.forEach(state => (state.active = true));
    this.storage.set(
      'activeSearchStates',
      activeStates?.filter(s => this.ds.isValue(s.value))
    );
    if (this.searchInputStates.length) activeStates = activeStates.concat(this.searchInputStates);

    // upate current search
    activeStates?.forEach(state => this.updateCurrentSearch(state.key, state.value));

    // proceed to query search if pageable or can search local // else just use native filter
    if (this.isPageable || this.allTableData.length) this.handlePage();
    else if (this.listData) this.listData.filter = state?.value?.toString()?.trim()?.toLowerCase();
  }

  getFullNameStates(fullNameInput: SearchState): SearchState[] {
    // if fullName, use [first sur], or [first middle sur] depending on spaces;
    const values = fullNameInput.value?.split(' ')?.filter(v => v?.trim()?.length);
    const fullNameParts = ['firstName', 'middleName', 'surname'];
    if (values?.length === 2) fullNameParts.splice(1, 1);
    const getKey = index => `${this.ds.getPrefix(fullNameInput.key, '.')}${fullNameParts[index]}`;
    return values?.map((value, index) => ({key: getKey(index), value, active: true}));
  }

  searchAllTableDataLocally(currentSearch: SearchFieldsDtoInput[]) {
    let resultSet = [...this.allTableData];
    const searchFields = [...currentSearch];
    if (!this.hasActiveStates()) return this.tableData.next(resultSet);

    searchFields.forEach(
      f =>
        (resultSet = resultSet.filter(r => {
          if (typeof f.fieldValue === 'number') return r[f.fieldName] === f.fieldValue;
          const typeIsNotEqual = f.searchType === SearchOperationType.NotEquals;
          if (typeIsNotEqual) return !this.ds.valueIncludes(r[f.fieldName], f.fieldValue, true);
          else return this.ds.valueIncludes(r[f.fieldName], f.fieldValue, true);
        }))
    );

    this.tableData.next(resultSet);
  }

  hasActiveStates() {
    return !!this.searchStates?.find(
      state => !state.locked && (!!state.value || state.value === false)
    );
  }

  updateCurrentSearch(key: string, value: number | string | boolean | any) {
    const state: SearchState = this.searchStates?.find(state => state.key === key);
    const searchStateValue = this.searchStatesValues?.find(s => s.key === key);
    let searchType = searchStateValue?.searchType ?? state?.searchType ?? this.searchOperationType;

    // remove inactive states;  // remove the selected search field from current search fields
    if (!searchStateValue) this.currentSearch = this.currentSearch.filter(s => s.fieldName !== key);

    //set search field // handle if date range
    const fieldName = key;
    const fieldValue = Array.isArray(value) ? value?.[0] : value;
    if (Array.isArray(value)) searchType = SearchOperationType.Between;
    const searchField: SearchFieldsDtoInput = {fieldName, searchType, fieldValue};
    if (Array.isArray(value)) searchField.fieldValues = value;

    // add the field back with the new values
    if (!this.currentSearch.find(s => s.fieldName === key)) this.currentSearch.push(searchField);

    // since we are using like to search,
    // we need to add search fields that will exclude similar results
    // to almost similar search values; e.g ICE vs CE
    const similarToOthers = v => v !== value && this.ds.valueIncludes(v, value, true);
    const otherSimilar = state?.values?.filter(v => similarToOthers(v));
    searchType = SearchOperationType.NotEquals;

    const getField = (fieldName, fieldValue) => ({fieldName, fieldValue, searchType});
    otherSimilar?.forEach(value => this.currentSearch.push(getField(key, value)));
  }

  clearSearchCustomState() {

    // only remove the states that are not locked (not in searchStateValues)
    const removeValue = s => !s.locked && ((s.value = undefined) || (s.active = false) || true);
    this.searchStates.forEach(state => removeValue(state) && this.removeSearchFields(state));
    this.storage.set(
      'activeSearchStates',
      this.searchStates.filter(s => s.active)
    );

    if (this.isPageable || this.allTableData.length) this.handlePage();
    else this.listData.filter = ''.trim().toLowerCase();
  }

  updateSearchInputStates(states: SearchState[]) {

    this.removeSearchFields(states);
    this.searchInputStates = states.filter(s => this.ds.isValue(s.value?.trim()));


    //for unpaged data search has no key
    const fullNameInput = this.searchInputStates.find(s => s.key && s.key.includes('fullName'));
    if (fullNameInput && fullNameInput?.value?.split(' ')?.length) {
      this.searchInputStates = this.searchInputStates
        .filter(s => !s.key.includes('fullName'))
        .concat(this.getFullNameStates(fullNameInput));
    }

    this.storage.set('searchInputStates', this.searchInputStates);
    this.filterTable();
  }

  sortChange(e: { active: string; direction: any }) {
    // // discipline.title = > displineTitle
    const direction = this.isPageable ? e?.direction?.toUpperCase() : e?.direction;
    this.currentSort = {sortBy: e.active, sortDirection: direction};
    this.handlePage();
  }

  onCellSelectionChange(e: any) {
    this.cellSelectionChange.emit((this.selectedCells = e));
  }

  onRowSelectionChange(e: any) {
    this.rowSelectionChange.emit((this.selectedRows = e));
  }

  filterTable() {
    if (!this.isPageable) {
      this.listData.filter = this.searchInputStates?.[0]?.value?.toLowerCase();
      this.listData = new MatTableDataSource(this.listData._filterData(this.visibleItemsMod));
      return;
    }

    this.pageParam = {...this.pageParam, first: 0};
    this.paginator?.firstPage();

    // filter static table // if input add it to current search
    this.hasTouchedSearchInput = true;
    this.listData.filter = this.searchInputStates?.[0]?.value?.toLowerCase();

    if (this.searchInputStates.length) {
      this.removeSearchFields(this.previousInputStates);
      (this.previousInputStates = this.searchInputStates)?.forEach(state =>
        this.updateCurrentSearch(state.key, state.value)
      );
    }

    this.handlePage();
  }

  removeSearchFields(keys_: any | SearchState[] | any[]) {
    if (!Array.isArray(keys_)) keys_ = [keys_];
    let keys: any[] = keys_;
    keys = keys.map(key => key?.fieldName ?? key?.key ?? key);
    this.currentSearch = this.currentSearch.filter(s => !this.ds.valueIsEither(s.fieldName, keys));
  }

  onSearchClear() {
    this.removeSearchFields(this.searchInputStates);
    this.storage.set('searchInputStates', (this.searchInputStates = []));
    this.pageIndex = 0;
    this.filterTable();
  }

  handlePage(e?: PageEvent) {
    if (e) {
      this.paginator.pageIndex = this.pageIndex = e.pageIndex;
      this.paginator._changePageSize((this.pageSize = e.pageSize));
      this.storage.set('pageDetails', {...e});
    }

    const searchLocal = !this.isPageable && this.allTableData.length;
    if (searchLocal) return this.searchAllTableDataLocally(this.currentSearch);

    //first: practically should be named page
    this.pageParam = {
      ...this.pageParam,
      ...this.currentSort,
      first: (this.pageIndex = e?.pageIndex ?? this.pageIndex ?? 0),
      size: e?.pageSize ?? this.pageSize,
      searchFields: this.currentSearch,
    };

    const noSearch = !this.currentSearch?.length && !this.searchInputStates.length;
    if (noSearch) delete this.pageParam.searchFields;
    if (!this.query) this.pageable.emit(this.pageParam);

    if (this.query) {
      if(!this.useOuterSearchField)
      {
        this.pageableParamInput = {...this.pageableParamInput, ...this.pageParam};
        if (noSearch) delete this.pageableParamInput.searchFields;
      }

    else{
        this.pageableParamInput = { ...this.pageableParamInput, ...this.pageParam, searchFields: this.currentSearch }
      }

      this.setTableDataFromQuery(this.query);
    }
  }

  rowClik(data: { rowData: any; index: number }) {
    if (!this.userIsInternal) return;

    const dialogData = {
      data: data?.rowData,
      showHeader: true,
      animation: this.animation,
      showFieldsInGroups: true,
    };

    this.st.multipleClickEvent(() => {
      this.vs.openModal({
        component: AllDetailsComponent,
        panelClass: ['scale-up'],
        width: '80%',
        height: '80%',
        data: dialogData,
      });
    }, 3);
  }

  async setTableDataFromQuery(query , selectValue? , index?) {
    this.queryIsRunning = true;
    const data = await this.getTableDataFromQuery(query ,undefined, selectValue , index);

    if (!this.isPageable) {
      this.allTableData = data;
      this.searchAllTableDataLocally(this.currentSearch);
    } else this.tableData.next(data);
    this.queryIsRunning = false;
  }

  async getTableDataFromQuery(query, variables? , selectValue? , index?) {
    let saveDetails = true;

    if (variables) saveDetails = false;
    variables = variables ?? this.getQueryVariables(query);

    if(selectValue?.value){
      variables[this.dropDownVariables[index]] = selectValue?.value
    }

    const response$ = this.apollo
      .query({
        query,
        variables,
        fetchPolicy: 'network-only',
        context: {headers: new HttpHeaders().set('ngLoader', 'false')}
      }).pipe(
        map(({data}: any) => data));

    const response = await lastValueFrom(response$).catch(e => {
      if (e.toString().includes('Access is denied')) {
        this.notify.errorMessage('You are not permitted to access this resource')
      }
    })
    return this.getDataFromResponse(response, saveDetails);
  }

  getQuerySearchDtoKey(query) {
    const keys: string[] = query?.definitions[0]?.variableDefinitions?.map(
      x => x?.variable?.name?.value
    ) ?? ['P'];
    return keys.find(k => this.ds.valueIncludes(k, 'pageableParam'));
  }

  getQueryVariables(query) {
    let keys: string[] = [];
    keys = query?.definitions[0]?.variableDefinitions?.map(x => x?.variable?.name?.value);
    keys = keys.filter(k => this.ds.isString(k));

    const noSize = this.pageableParamInput?.size < 1;
    if (noSize) this.pageableParamInput.size = 10;

    //auto add the pagedData input and queryVariables when available
    let variables = {},
      index;
    if (keys.length) {
      const isSearch = (index = keys?.findIndex(k => this.ds.valueIncludes(k, 'pageableParam'))) > -1;
      if (isSearch) variables[keys[index]] = this.pageableParamInput;
      if (this.queryVariables) variables = {...variables, ...this.queryVariables};
    }
    return variables;
  }

  getDataFromResponse(data, saveDetails = true) {
    if (!data) return [];
    const fields: { key: string; value: any }[] = [];
    let result: PageableResponse<any>, response: any;
    let pageDetails: any = {};
    Object.keys(data)?.forEach(key => fields.push({key, value: data[key]}));

    //get data list
    if (!(response = fields[0]?.value)) return [];
    else if (Array.isArray(response?.content)) result = response;
    else if (Array.isArray(response?.data?.content)) result = response.data;
    else if (Array.isArray(response?.data)) result = {content: response.data};
    else if (Array.isArray(response?.dataList)) result = {content: response.dataList};
    else if (Array.isArray(response)) result = {content: response};

    this.isPageable = !!result?.content;
    if (!result?.content) return this.resetPageDetails(fields[0].key);

    pageDetails = {query: fields[0].key, ...result};
    const content = [...pageDetails?.content];
    delete pageDetails?.content;

    if (saveDetails) this.storage.set(pageDetails.query, pageDetails);
    return content;
  }

  resetPageDetails(pageDetailsKey) {
    let pageDetails = this.storage.get(pageDetailsKey);
    if (!pageDetails) pageDetails = this.storage.get('pageDetails');
    if (!pageDetails) return [];
    pageDetails.totalElements = 0;
    this.storage.set(pageDetailsKey, pageDetails);
    return [];
  }

  getQueryKey(query: any) {
    if (!query) return 'pageDetails';
    const key = query?.definitions[0]?.name?.value;
    return key ?? 'pageDetails';
  }

  setDefaultColumnsKeys() {
    if (this.selectedColumnsKeys.length) return;
    let keys = this.columnsKeys;
    if (this.columnHeader) keys = this.fs.fieldsArrayFromObj(this.columnHeader).map(f => f.key);
    if (this.columns) keys = this.columns.map(c => c.field);
    const notCol = ['action', 'query', 'actions', 'sno', 'index', 'no'];
    this.selectedColumnsKeys = keys.filter(k => !this.ds.valueIsEither(k, notCol));
    if (!this.defaultColumnsKeys.length)
      this.defaultColumnsKeys = this.selectedColumnsKeys.reverse();
  }

  changeDisplayedColumns(keys) {
    this.selectedColumnsKeys = keys.length ? keys : this.defaultColumnsKeys;
    const columnHeader_ = {};
    this.selectedColumnsKeys.forEach(key => (columnHeader_[key] = this.ds.camelToTitleCase(key)));

    // retain those special columns  // add those selected
    this.columnHeader = {index: 'S/N', ...columnHeader_, actions: 'Actions'};
    this.setMtxColumns(this.columnHeader);
  }

  // update positions of columns if change is from the grid

  columnChange(columns: MtxGridColumn[]) {
    const findIndex = x => columns.map(c => c.field).findIndex(k => k === x);
    this.selectedColumnsKeys.sort((a, b) => findIndex(b) - findIndex(a));
    this.sortAllFieldsKeys(this.selectedColumnsKeys);
  }

  sortAllFieldsKeys(keys) {
    this.allFieldsKeys.sort((a, b) => a?.localeCompare(b));
    const getIndex = k => keys?.findIndex(k_ => k_ == k);
    this.allFieldsKeys.sort((a, b) => getIndex(b) - getIndex(a));
  }

  setEntityKeysGroups(sampleModItem: any, sampleItem: any) {
    const hidden = ['sn', 'id', 'actions', 'reportQuery'];
    let allKeys = this.fs.fieldsArrayFromObj(sampleModItem).map(f => f.key);
    allKeys = allKeys?.filter(k => !this.ds.valueIncludes(k, hidden, true));

    if (this.userIsInternal) this.allFieldsKeys = allKeys;
    else if (this.hiddenFieldsKeys.concat(END_USER_HIDDEN_FIELDS).length) {
      const notHidden = k => !this.ds.valueIncludes(k, this.hiddenFieldsKeys);
      this.allFieldsKeys = allKeys?.filter(key => notHidden(key));
    } else this.allFieldsKeys = this.defaultColumnsKeys;

    // sort keys // by alphabet  // by keys included in columns
    this.sortAllFieldsKeys(this.defaultColumnsKeys);

    const notHidden = k => !this.ds.valueIncludes(k, hidden, true);
    const allOgKeys = this.fs.fieldsArrayFromObj(sampleItem).map(f => f.key);
    this.originalFieldsKeys = allOgKeys?.filter(k => notHidden(k));

    // set search key and default exported columns
    if (!this.selectedExportKeys?.length) {
      const keys = this.exportAllFields ? this.originalFieldsKeys : this.columns.map(c => c.field);
      this.selectedExportKeys = keys;
    }

    if (this.searchByAllFields) {
      const isSearchable = k => !this.ds.valueIncludes(k, this.searchHiddenKeys, true);
      this.searchKeys = this.originalFieldsKeys?.filter(k => isSearchable(k)) ?? [];
      this.setSearchFieldsFromKeys();
    }

    const isDateKey = k => this.ds.valueIncludes(k, [this.selectedDateRangeKey, 'date']);
    const hasDateValue = k => this.ds.isValidDate(sampleItem[k]);
    this.allDateKeys = this.originalFieldsKeys.filter(k => isDateKey(k) || hasDateValue(k));
    this.dateFilterKeys = this.ds.mergeUnique(this.dateFilterKeys, this.allDateKeys);

    if (!this.allDateKeys.length) return;
    if (!this.selectedDateRangeKey) this.selectedDateRangeKey = this.dateFilterKeys[0];
    if (!this.selectedDateKey) this.selectedDateKey = this.dateFilterKeys[0];
  }

  async exportExel() {
    const THRESHOLD = 300; // Max size threshold for records per file
    let size = this.isPageable ? this.pageSize : this.dataLength; // Default export size
    let exportAll = this.exportAllData;

    // Step 1: Handle pageable data
    if (this.isPageable && !exportAll && this.dataLength > size) {
      const pageableMessage = `${this.dataLength} records found. Confirm to export all records or just ${size}.`;
      const exportAllRes = await this.notify.confirmation({ message: pageableMessage });

      if (exportAllRes?.isConfirmed) {
        exportAll = true; // User confirmed to export all data
      } else if (exportAllRes?.isDismissed) {
        // Export only the current page size
        return this.exportExcelRecursively(size, exportAll);
      }
    }

    // Step 2: Set size for all data export
    if (exportAll) {
      size = this.dataLength;
    }

    // Step 3: Handle batch export if size exceeds the threshold
    let batchSize = size; // Initialize batch size with the default size
    if (size > THRESHOLD) {
      const batchMessage = `Records exceed ${THRESHOLD}, which may take time. 
      Suggest size per file or leave empty to download all records in a single file.`;
      const label = 'Records per File';
      const sizeRes = await this.notify.inputDialogue(batchMessage, 'text', label, `Default ${THRESHOLD}`);

      // Validate user input for batch size
      const inputSize = isNaN(+sizeRes?.value) ? size : +sizeRes?.value;
      batchSize = Number.isNaN(inputSize) || inputSize <= 0 ? size : inputSize;
      batchSize = Math.min(batchSize, this.dataLength); // Ensure batch size doesn't exceed total data length
    }

    // Step 4: Prepare confirmation message
    const exportLength = size;
    let confirmMessage = `Export ${exportLength} records`;

    if (exportAll && batchSize < this.dataLength) {
      const batchCount = Math.ceil(this.dataLength / batchSize);
      confirmMessage += ` in batches of ${batchSize} records. This will generate ${batchCount} separate documents.`;
    } else {
      confirmMessage += ` in a single document.`;
    }

    const confirmRes = await this.notify.confirmation({ message: confirmMessage });

    // Step 5: Initiate export if confirmed
    if (confirmRes?.isConfirmed) {
      return this.exportExcelRecursively(batchSize, exportAll);
    }
  }
  async exportExcelRecursively(size, exportAll) {
    let visibleItems = this.visibleItemsMod;

    if (exportAll) {
      const variables = this.getQueryVariables(this.query);
      const key_ = this.getQuerySearchDtoKey(this.query);
      const hasParam = !!variables?.[key_]?.pageableParam?.size;
      hasParam && (variables[key_].pageableParam.size = size);
      hasParam && (variables[key_].pageableParam.first = this.exportPageIndex);
      const items = await this.getTableDataFromQuery(this.query, variables , undefined , undefined);
      visibleItems = items.map(item => this.fs.mapVisibleItem(item));
    }

    // only include fields that are selected for export
    visibleItems = visibleItems.map((item, index) => {
      const fields = this.fs.formatFields(this.fs.fieldsArrayFromObj(item));
      const itemMod = {index: index + 1 + this.exportPageIndex * size};
      fields.forEach(
        field =>
          this.selectedExportKeys.find(k => k === field.key) &&
          (itemMod[field.key] = field?.value?.toString())
      );
      return itemMod;
    });

    const columns = [];
    const allFields = this.fs.setFieldsWidths(visibleItems);
    const getColumn = (header, key, width): Column | any => ({header, key, width});
    allFields.forEach(field => columns.push(getColumn(field.name, field.key, field.length)));
    const fileName = this.getExportedFileName(size, visibleItems.length);
    await this.filesService.exportExcel(visibleItems, columns, fileName, this.title);

    // loop for all remaining pages if available
    const thereIsMore = exportAll && ++this.exportPageIndex < this.dataLength / size;
    if (thereIsMore) this.exportExcelRecursively(size, exportAll);
    else this.exportPageIndex = 0;
  }

  getExportedFileName(size, length?) {
    let fileName = `${APP_NAME} ${this.title}`;

    this.searchInputStates.forEach(s => (fileName = `${fileName} - (${s.key}=${s.value})`));
    if (this.dateValue) fileName = `${fileName} on ${this.dateValue}`;
    const date1 = this.ds.formatDate(this.startDateValue, 'dd-MMM-y');
    if (this.startDateValue && !this.endDateValue) fileName = `${fileName} on ${date1}`;
    if (this.startDateValue && this.endDateValue) fileName = `${fileName} from ${date1}`;

    const date2 = this.ds.formatDate(this.endDateValue, 'dd-MMM-y');
    if (this.endDateValue) fileName = `${fileName} to ${date2}`;
    if (length) fileName = `${fileName} (${length})`;
    fileName = `${this.ds.replaceSpaces(fileName, '_')}`;

    const inMultiples = this.exportAllData && this.isPageable && this.dataLength !== size;
    if (inMultiples) fileName = `${fileName}-page-${this.exportPageIndex + 1}`;
    return fileName;
  }

  clearFilterDate() {
    this.dateValue = undefined;
    this.removeSearchFields(this.selectedDateKey);
    this.handlePage();
  }

  filterByDate($event) {
    this.removeSearchFields(this.selectedDateKey);
    const fieldValue = (this.dateValue = this.ds.formatDate($event, 'yyyy-MM-dd'));
    const searchType = SearchOperationType.Like;
    this.currentSearch.push({fieldName: this.selectedDateKey, searchType, fieldValue});
    this.handlePage();
  }

  clearDateRangeFilter() {
    this.startDateValue = undefined;
    this.endDateValue = undefined;
    this.removeSearchFields(this.selectedDateRangeKey);
    this.handlePage();
  }

  filterByDateRange() {
    this.removeSearchFields(this.selectedDateRangeKey);
    let fromDate, toDate;

    if (this.startDateValue) fromDate = this.ds.formatDate(this.startDateValue, 'yyyy-MM-dd');
    if (this.endDateValue) toDate = this.ds.formatDate(this.endDateValue, 'yyyy-MM-dd');

    const err_msg = 'You have to fill in Start Date or End Date first';
    const hasNotSet = !this.startDateValue || !this.endDateValue;
    if (hasNotSet) return this.notify.errorMessage(err_msg);

    const fieldName = this.selectedDateRangeKey;
    const searchType = SearchOperationType.Between;
    const fieldValues = [fromDate, toDate];
    const fieldValue = toDate;
    const canSearch = fromDate && toDate && fieldName;

    if (canSearch) this.currentSearch.push({fieldName, searchType, fieldValue, fieldValues});
    this.handlePage();
  }

  setPageSize(value) {
    value = +value;
    // console.log(value) // go two time with a NAN
    if (Number.isNaN(value)) return;
    if (value) return this.pageSize = value;
    if (this.pageSize < 1) return (this.pageSize = this.paginator.pageSize);
    this.paginator.pageSize = this.pageSize;
    this.paginator._changePageSize(this.pageSize);
    this.updatePageDetails();
    this.handlePage();
  }

  setPageIndex(value) {
    value = +value;
    // console.log(value)
    if (Number.isNaN(value)) return;
    const notValid = Number.isNaN(value) || value > this.pagesLength || value < 0;
    if (notValid) return this.updatePageDetails();
    this.paginator.pageIndex = this.pageIndex = value - 1;
    this.paginator._changePageSize(this.pageSize);
    this.updatePageDetails();
    this.handlePage();
  }

  updatePageDetails() {
    this.displayedPageIndex = this.pageIndex + 1;
    this.pagesLength = Number((this.dataLength / this.pageSize).toFixed(0));
    if (this.dataLength && this.pagesLength < 1) this.pagesLength = 1;
  }

  async  getDataForSelect(){
    if(this.selectQuery){

      for(let item=0 ; item<  this.selectQuery.length ;item++){
        if(this.isEnum[item]){
          this.dropDownData.push(this.selectQuery[item])
        }else {
          try {
            const  data = await  this.graphqlService.query(
                {
                  query:this.selectQuery[item],
                  variables:{
                    pageableParam: {
                      first: 0,
                      size: 300,
                      sortBy: 'id',
                      sortDirection: 'DESC',
                      searchFields: []
                    },
                  }
                }
            )

            const results:any = Object.values(Object.values(data)[0])[0]

            if (results?.content){
              this.dropDownData.push(results?.content);
            }
            else {
              this.dropDownData.push(results)
            }
            console.log(results)

          }catch (error){
            this.dropDownData.push([]);
          }
        }
      }


    }
  }


}
